import { useSearchParams } from "react-router-dom";
import { products, categories } from "../data";
import { ProductCard } from "../components/Cards";
import { ScrollReveal, StaggerContainer, StaggerItem } from "../components/ScrollReveal";

const Products = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const categoryParam = searchParams.get("category");
  
  // Determine active category - default to "Alle" if param is missing or explicitly set to "Alle"
  const activeCategory = (!categoryParam || categoryParam === "Alle") ? "Alle" : categoryParam;

  const handleCategoryChange = (category) => {
    if (category === "Alle" || category === activeCategory) {
      setSearchParams({}, { replace: true });
    } else {
      setSearchParams({ category }, { replace: true });
    }
  };

  // Improved filtering logic with normalization
  const filteredProducts = activeCategory === "Alle" 
    ? products 
    : products.filter(product => 
        product.category.toLowerCase().trim() === activeCategory.toLowerCase().trim()
      );

  return (
    <div className="bg-white min-h-screen">
      {/* Hero Section */}
      <section className="relative py-20 lg:py-32 bg-slate-50 overflow-hidden">
        <div className="container-custom relative z-10">
          <div className="max-w-3xl">
            <h1 className="text-4xl md:text-6xl font-semibold tracking-tighter text-slate-900 mb-6">
              Vores <span className="text-blue-600">Produkter</span>
            </h1>
            <p className="text-xl text-slate-600 leading-relaxed">
              Udforsk vores sortiment af unikke 3D-printede kreationer. Alt er produceret lokalt med fokus på detaljen.
            </p>
          </div>
        </div>
        <div className="absolute top-0 right-0 w-1/3 h-full bg-slate-100 -skew-x-12 transform translate-x-20 hidden lg:block"></div>
      </section>

      <div className="section-padding">
        <div className="container-custom">
          <ScrollReveal className="flex justify-center mb-16">
            {/* Categories */}
            <div className="flex flex-wrap gap-3 justify-center">
              {categories.map(category => (
                <button
                  key={category}
                  onClick={() => handleCategoryChange(category)}
                  className={`px-6 py-2.5 text-sm font-semibold transition-all rounded-none ${
                    activeCategory.toLowerCase().trim() === category.toLowerCase().trim()
                      ? "bg-slate-900 text-white shadow-xl shadow-slate-300 transform -translate-y-0.5"
                      : "bg-white text-slate-600 hover:bg-white hover:text-slate-900 hover:shadow-md"
                  }`}
                >
                  {category}
                </button>
              ))}
            </div>
          </ScrollReveal>

          {filteredProducts.length > 0 ? (
            <StaggerContainer 
              key={activeCategory} 
              className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-8"
            >
              {filteredProducts.map(product => (
                <StaggerItem key={`${activeCategory}-${product.id}`}>
                  <ProductCard product={product} />
                </StaggerItem>
              ))}
            </StaggerContainer>
          ) : (
            <ScrollReveal className="text-center py-24 bg-white border border-dashed border-slate-300">
              <p className="text-slate-500 text-xl mb-6">Ingen produkter matcher det valgte filter.</p>
              <button 
                onClick={() => handleCategoryChange("Alle")}
                className="px-8 py-3 bg-slate-900 text-white font-semibold hover:bg-slate-800 transition-colors"
              >
                Vis alle produkter
              </button>
            </ScrollReveal>
          )}
        </div>
      </div>
    </div>
  );
};

export default Products;
